import createIcon from '../../createIcon';

/**
 * @component @name Propane
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgNkgxNlY1QzE2IDMuOSAxNS4xIDMgMTQgM0gxMEM4LjkgMyA4IDMuOSA4IDVWNkg3QzMuNjkgNiAxIDguNjkgMSAxMkMxIDE1LjMxIDMuNjkgMTggNyAxOFYyMUg5VjE4SDE1VjIxSDE3VjE4QzIwLjMxIDE4IDIzIDE1LjMxIDIzIDEyQzIzIDguNjkgMjAuMzEgNiAxNyA2Wk0xMCA1SDE0VjZIMTBWNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Propane = createIcon('Propane', [
  [
    'path',
    {
      d: 'M17 6H16V5C16 3.9 15.1 3 14 3H10C8.9 3 8 3.9 8 5V6H7C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18V21H9V18H15V21H17V18C20.31 18 23 15.31 23 12C23 8.69 20.31 6 17 6ZM10 5H14V6H10V5Z',
      key: '16hshs',
    },
  ],
]);

export default Propane;
